import * as React from 'react';
import _ from 'lodash';
import Paper from '@mui/material/Paper';
import SvgLockIcon from '../../../static/icons/svgLockIcon';
import { Company } from '../../../reducers/types';
import PaidPlan from '../PaidPlan/PaidPlan';
const styles = require('./styles.pcss');

type PlansSectionProps = {
  company: Company;
};

const PlansSection: React.FC<PlansSectionProps> = ({ company }) => {
  let paperStyle = styles.paper;

  return (
    <Paper className={paperStyle}>
      <div className={styles.plansSectionHeader}>
        <div className={styles.plansSectionHeaderIconContainer}>
          <SvgLockIcon
            width={32}
            height={32}
          />
        </div>
        <div className={styles.plansSectionHeaderText}>
          <h2>Subscription Details</h2>
          <div className={styles.description}>
            Settings for the company's subscription level and paid plan. Please
            note that any enabled feature flags will still apply.
          </div>
        </div>
      </div>
      <PaidPlan company={company} />
    </Paper>
  );
};

export default PlansSection;
